import script from "./FeedbackAssessmentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackAssessmentDialog.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackAssessmentDialog.vue?vue&type=style&index=0&id=5da1ca9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da1ca9a"]])

export default __exports__